'use strict';

const jQuery = require('jquery');

module.exports.resize = (file, width, height, quality) => {
    let reader = new FileReader();
    let dfd = jQuery.Deferred();

    reader.onload = function(readerEvent) {
        let image = new Image();

        image.onload = function() {
            let canvas = document.createElement('canvas');

            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);

            dfd.resolve(canvas.toDataURL(file.type, quality / 100).replace(new RegExp('^data:' + file.type + ';base64,', 'g'), ''));
        };

        image.src = readerEvent.target.result;
    };

    reader.readAsDataURL(file);

    return dfd.promise();
};
